<!-- Button -->
<button type="button"
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">
        <mat-icon class="w-8 h-8"
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="'mat_outline:account_circle'">
        </mat-icon>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button type="button" mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user.userName}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button type="button"
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'mat_outline:logout'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
